<div headerTitle="{{'SystemAdmin.Components.RecordBaseItem.Header.Title' | translate}}" app-item-property-container>

    <ng-container headerActions>{{recordBase.recordState | globalEnumPipe: 'recordState' | translate}}</ng-container>

    <div class="flow-root">
        <ul role="list" class="divide-y divide-gray-200 dark:divide-gray-700">
            <li class="py-3 sm:py-4">
                <div class="flex items-center space-x-4">
                    <div class="flex-shrink-0">
                        <img class="w-12 h-12 rounded-full object-cover" [src]="dataService.getAvatarPhoto(recordBase.createdById)"
                            (error)="imageErrorHandler($event)" [alt]="recordBase.createdByName">
                    </div>
                    <div class="flex-1 min-w-0">
                        <p class="text-sm font-medium text-gray-900 truncate dark:text-white">
                           {{'SystemAdmin.Common.RecordBase.CreatedBy' | translate}}
                        </p>
                        <p class="text-sm text-gray-500 truncate dark:text-gray-400">
                            <a [routerLink]="['/users', recordBase.createdById]"
                                target="_blank">{{recordBase.createdByName}}</a>
                        </p>
                    </div>
                    <div class="inline-flex items-center text-base font-normal text-gray-900 dark:text-white">
                        {{recordBase.createdAt | datetimeFormat: 'L'}} <span
                            class="ml-1 font-medium">{{recordBase.createdAt | datetimeFormat: 'LTS'}}</span>
                    </div>
                </div>
            </li>
            <li class="py-3 sm:py-4">
                <div class="flex items-center space-x-4">
                    <div class="flex-shrink-0">
                        <img class="w-12 h-12 rounded-full object-cover" [src]="dataService.getAvatarPhoto(recordBase.updatedById)"
                            (error)="imageErrorHandler($event)" [alt]="recordBase.updatedByName">
                    </div>
                    <div class="flex-1 min-w-0">
                        <p class="text-sm font-medium text-gray-900 truncate dark:text-white">
                            {{'SystemAdmin.Common.RecordBase.LastModifiedBy' | translate}}
                        </p>
                        <p class="text-sm text-gray-500 truncate dark:text-gray-400">
                            <a [routerLink]="['/users', recordBase.updatedById]"
                                target="_blank">{{recordBase.updatedByName}}</a>
                        </p>
                    </div>
                    <div class="inline-flex items-center text-base font-normal text-gray-900 dark:text-white">
                        {{recordBase.updatedAt | datetimeFormat: 'L'}} <span
                            class="ml-1 font-medium">{{recordBase.updatedAt | datetimeFormat: 'LTS'}}</span>
                    </div>
                </div>
            </li>

        </ul>
    </div>
</div>